import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import {
  IServerCatalogItem,
  ISkincareThresholdSettings,
  IUpsertSkincareThresholdSettingsInput
} from '../models/catalog';
import { IKitMatrix } from '../../motor-kits-skincare/models/kit-matrix.interface';

export type CatalogListResponse = {
  catalog: IServerCatalogItem[];
};

@Injectable({
  providedIn: 'root'
})
export class CatalogoProdutosService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}SkincareCatalog`;

  constructor(private readonly http: HttpClient, protected readonly toast: ToastService) {
    super(toast);
  }

  importarCatalogo(file: File, companyId: string): Observable<ResponseDefault<boolean>> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('companyId', companyId);

    return this.http.post<ResponseDefault<boolean>>(`${this.apiUrl}/ImportCatalog`, formData);
  }

  listarCatalogoPorCompanyId(companyId: string): Observable<ResponseDefault<CatalogListResponse>> {
    return this.http.get<ResponseDefault<CatalogListResponse>>(`${this.apiUrl}/Catalog/${companyId}`);
  }

  listarThresholdsDefault(): Observable<ResponseDefault<ISkincareThresholdSettings>> {
    return this.http.get<ResponseDefault<ISkincareThresholdSettings>>(`${this.apiUrl}/Thresholds/Default`);
  }

  salvarThresholdsDefault(payload: IUpsertSkincareThresholdSettingsInput): Observable<ResponseDefault<ISkincareThresholdSettings>> {
    return this.http.put<ResponseDefault<ISkincareThresholdSettings>>(`${this.apiUrl}/Thresholds/Default`, payload);
  }

  listarThresholdsPorCompanyId(companyId: string): Observable<ResponseDefault<ISkincareThresholdSettings>> {
    return this.http.get<ResponseDefault<ISkincareThresholdSettings>>(`${this.apiUrl}/Thresholds/${companyId}`);
  }

  salvarThresholds(companyId: string, payload: IUpsertSkincareThresholdSettingsInput): Observable<ResponseDefault<ISkincareThresholdSettings>> {
    return this.http.put<ResponseDefault<ISkincareThresholdSettings>>(`${this.apiUrl}/Thresholds/${companyId}`, payload);
  }

  resetarThresholds(companyId: string): Observable<ResponseDefault<ISkincareThresholdSettings>> {
    return this.http.delete<ResponseDefault<ISkincareThresholdSettings>>(`${this.apiUrl}/Thresholds/${companyId}`);
  }

  /** Configuracao do motor de kits da empresa. `data` nulo = empresa usa scoring. */
  listarKitMatrix(companyId: string): Observable<ResponseDefault<IKitMatrix | null>> {
    return this.http.get<ResponseDefault<IKitMatrix | null>>(`${this.apiUrl}/KitMatrix/${companyId}`);
  }

  salvarKitMatrix(companyId: string, payload: IKitMatrix): Observable<ResponseDefault<IKitMatrix>> {
    return this.http.put<ResponseDefault<IKitMatrix>>(`${this.apiUrl}/KitMatrix/${companyId}`, payload);
  }

  removerKitMatrix(companyId: string): Observable<ResponseDefault<boolean>> {
    return this.http.delete<ResponseDefault<boolean>>(`${this.apiUrl}/KitMatrix/${companyId}`);
  }
}
